import { render } from "./delivery-report.vue?vue&type=template&id=dcc74a8a"
import script from "./delivery-report.vue?vue&type=script&lang=js"
export * from "./delivery-report.vue?vue&type=script&lang=js"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__